// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/square-check-big.js';

import { paths } from '../generated/square-check-big';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('square-check-big', Original, paths);
